module.exports = __webpack_public_path__ + "img/pn.3aa5bee6.svg";